import "babel-polyfill";
import "element-closest-polyfill";
import "intersection-observer";
import "matchmedia-polyfill";
import "matchmedia-polyfill/matchMedia.addListener";
import "proxy-polyfill";
import "whatwg-fetch";
import "url-polyfill";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { HashRouter as Router } from "react-router-dom";
import App from "./app/App";
import "@fortawesome/fontawesome-free/js/all.min.js";
import "./index.scss";

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
window.FontAwesome.config.autoReplaceSvg = "nest";

/** @ignore import registerServiceWorker from "./registerServiceWorker"; */

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root") as HTMLElement
);
/* @ignore registerServiceWorker();

// Unregister Service Workers, if present
navigator.serviceWorker.getRegistrations().then(registrations => {
  for (const registration of registrations) {
    registration.unregister();
  }
}); */
